
// utils.js
export function showFile(src, extension) { 
    const type = ['pdf'].includes(extension.toLowerCase()) ? 'iframe' : 'image';
    if (window.$ && window.$.magnificPopup) {
        window.$.magnificPopup.open({
            items: {
                src: src
            },
            type: type
        });
    } else {
        console.error("Magnific Popup no está cargado.");
    }
}
export function visor(){
    alert(9);
}